export { default } from "./ServicePointCard";
